import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import client from '../shopify';
import ProductCard from '../components/ProductCard';

const Container = styled.div`
  padding: 20px 40px;
  
  @media (max-width: 600px) {
    padding: 10px 15px;
  }
`;

const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 10px;
  
  /* Responsive grid adjustments */
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;

// Statement pieces live on the Statements page instead of Staples
export const STATEMENT_HANDLES = ['knit-soccer-jersey'];

const Staples = ({ sortOrder, statements = false }) => {
  const [products, setProducts] = useState([]);
  
  // Custom product order using exact Shopify titles (maps your desired order)
  // 1) Chalk zip
  // 2) Black zip
  // 3) White tee
  // 4) Chalk tee
  // 5) Black tee
  // 6) Chalk sweat
  // 7) Navy hoodie
  // 8) White tank
  // 9) Chalk tank
  // 10) Navy tank
  // 11) Black tank
  // 12) Navy Sweatpant
  const customProductOrder = [
    "Boxy Double Zip Hoodie In Chalk",
    "Boxy Double Zip Hoodie In Black",
    "Boxy Tee In White",
    "Boxy Tee In Chalk",
    "Boxy Tee In Black",
    "Flared Sweatpant In Chalk",
    "Boxy Pullover Hoodie In Navy",
    "Pleated Guinea Tee In White",
    "Pleated Guinea Tee In Chalk",
    "Pleated Guinea Tee In Navy",
    "Pleated Guinea Tee In Black",
    "Sausage Cuffed Sweatpant In Navy"
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      const productsQuery = `
        {
          products(first: 50, sortKey: TITLE) {
            edges {
              node {
                id
                title
                handle
                images(first: 1) {
                  edges {
                    node {
                      src
                    }
                  }
                }
                priceRange {
                  minVariantPrice {
                    amount
                  }
                }
              }
            }
          }
        }
      `;

      try {
        const response = await client.request(productsQuery);
        setProducts(response.data.products.edges);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  const sortedProducts = products
    .filter(({ node }) => STATEMENT_HANDLES.includes(node.handle) === statements)
    .sort((a, b) => {
      if (sortOrder === 'price-asc') {
        return a.node.priceRange.minVariantPrice.amount - b.node.priceRange.minVariantPrice.amount;
      } else if (sortOrder === 'price-desc') {
        return b.node.priceRange.minVariantPrice.amount - a.node.priceRange.minVariantPrice.amount;
      } else {
        // Default to custom order
        const indexA = customProductOrder.findIndex(title => title === a.node.title);
        const indexB = customProductOrder.findIndex(title => title === b.node.title);
      
        // If both products are in the custom order list
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
      
        // If only product A is in the list, it comes first
        if (indexA !== -1) return -1;
      
        // If only product B is in the list, it comes first
        if (indexB !== -1) return 1;
      
        // If neither product is in the list, maintain original order
        return 0;
      }
    });

  return (
    <Container>
      <ProductGrid>
        {sortedProducts.map(({ node: product }) => (
          <ProductCard
            key={product.id}
            id={product.handle}
            image={product.images.edges[0]?.node.src}
            title={product.title}
            price={product.priceRange.minVariantPrice.amount}
          />
        ))}
      </ProductGrid>
    </Container>
  );
};

export default Staples;
